import { H3HexagonLayer } from 'deck.gl';
import { gridDisk } from 'h3-js';

// Demarca el area de captacion del primer orden: todas las celdas que la celda
// elegida alcanza caminando en 30 minutos. Sin esto, el pulso parece expandirse
// sin limite; el area lo hace explicito. Relleno dorado tenue en toda la zona y
// una linea mas marcada en el borde (celdas con algun vecino fuera del area).
const DORADO = [255, 213, 74];
const HORIZONTE_MIN = 30;

// Calcula las celdas del area y marca cuales estan en el borde. Se memoiza en
// App (depende solo de la celda elegida), no se recalcula en cada frame.
export function calculaAreaEscaneo(origenH3, isocronas, grilla) {
  if (!origenH3) return null;
  const pares = isocronas && isocronas[origenH3];
  const dentro = new Set();
  if (pares) {
    for (const [idx, minutos] of pares) {
      if (minutos <= HORIZONTE_MIN) {
        const fila = grilla[idx];
        if (fila) dentro.add(fila.h3);
      }
    }
  } else {
    // Respaldo sin isocronas reales: un disco topologico como aproximacion.
    for (const h3 of gridDisk(origenH3, 10)) dentro.add(h3);
  }
  if (dentro.size === 0) return null;

  const celdas = [];
  for (const h3 of dentro) {
    let borde = false;
    for (const vecino of gridDisk(h3, 1)) {
      if (vecino !== h3 && !dentro.has(vecino)) {
        borde = true;
        break;
      }
    }
    celdas.push({ h3, borde });
  }
  return celdas;
}

export function construyeCapaAreaEscaneo(celdas) {
  if (!celdas || celdas.length === 0) return null;
  return new H3HexagonLayer({
    id: 'area-escaneo',
    data: celdas,
    pickable: false,
    filled: true,
    stroked: true,
    extruded: false,
    highPrecision: 'auto',
    parameters: { depthTest: false },
    getHexagon: (d) => d.h3,
    getFillColor: (d) => [...DORADO, d.borde ? 32 : 14],
    getLineColor: (d) => (d.borde ? [...DORADO, 195] : [0, 0, 0, 0]),
    getLineWidth: (d) => (d.borde ? 1.6 : 0),
    lineWidthUnits: 'pixels',
    lineWidthMinPixels: 1,
    updateTriggers: {
      getFillColor: [celdas],
      getLineColor: [celdas],
    },
  });
}
